module.exports = __webpack_public_path__ + "static/media/view leave hr.74b423ce.svg";